import React from "react";

const AdminCard = ({ children, className = "" }) => {
  return (
    <div
      className={`bg-white rounded-3xl border border-slate-100 shadow-soft p-5 lg:p-6 ${className}`}
    >
      {children}
    </div>
  );
};

export default AdminCard;
